module.exports = __webpack_public_path__ + "static/img/4471_phase_function_Paper_Points.e78fc66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4471_phase_function_Paper_Points.png
// module id = Nsgn
// module chunks = 0